import React from "react";
import { Button } from "./Button";

export function CheckoutButton({ onClick, isLoading, disabled }) {
  return (
    <Button
      onClick={onClick}
      isLoading={isLoading}
      text="Confirm Payment"
      className="w-full py-3 text-base"
      disabled={disabled}
    />
  );
}